/*
 * Copyright 2022-present terrestris GmbH & Co. KG
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
import React from 'react';

import {
  faExpand
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import ZoomToExtentButton, {
  ZoomToExtentButtonProps
} from '@terrestris/react-geo/dist/Button/ZoomToExtentButton/ZoomToExtentButton';

import { useMap } from '@terrestris/react-util';

import './ProjectZoomToExtentButton.less';

export const ProjectZoomToExtentButton: React.FC<Partial<ZoomToExtentButtonProps>> = (props): React.JSX.Element => {
  const map = useMap();

  if (!map) {
    return <></>;
  }

  const extent = [919697.5, 6961480.5, 955537.5, 6997320.5]; // todo: make configurable

  return (
    <ZoomToExtentButton
      tooltip='Zur Startansicht zurückkehren'
      constrainViewResolution={true}
      tooltipProps={{
        mouseEnterDelay: .1,
        placement: 'right'
      }}
      extent={extent}
      icon={
        <FontAwesomeIcon
          icon={faExpand}
        />
      }
    />
  );
};

export default ProjectZoomToExtentButton;
